const roundToNearest10 = (number: number) => Math.round(number / 10) * 10

export const formatToDKK = (number: number) => {
  const roundedToNearest10 = roundToNearest10(number)
  const formattedString = new Intl.NumberFormat('da-DK', {
    style: 'currency',
    minimumFractionDigits: 0,
    currency: 'DKK',
  }).format(roundedToNearest10)

  return formattedString
}

export const getMonthName = (monthNumber: number) => {
  const date = new Date()
  date.setMonth(monthNumber - 1)
  return date.toLocaleString('da-DK', { month: 'long' })
}
